import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { integrationService } from '../services/integrations.service';

/**
 * Hook para eliminar la autorización de YPF.
 *
 * @returns La mutation para eliminar la autorización de YPF.
 */
export const useDeleteYpfAuth = (): UseMutationResult<void, Error, void> => {
    return useMutation<void, Error, void>({
        mutationFn: async () => {
            await integrationService.deleteYpfAuthorization();
        },
    });
};
